<template>
  <section
    class="bg-ontick-green-700 dark:bg-ontick-steel-600 dark:bg-opacity-40"
  >
    <div class="mx-auto max-w-7xl md:grid md:grid-cols-2 md:px-6 lg:px-8">
      <div
        v-for="(testimonial, index) in data"
        :key="index"
        class="py-12 px-4 sm:px-6 md:flex md:flex-col md:py-16 md:pl-0 md:pr-10 lg:pr-16"
      >
        <blockquote class="mt-6 md:flex md:flex-grow md:flex-col">
          <div
            class="relative text-lg text-white dark:text-gray-300 md:flex-grow"
          >
            <svg
              class="text-ontick-green-600 absolute top-0 left-0 h-8 w-8 -translate-x-3 -translate-y-2 transform dark:text-opacity-40"
              fill="currentColor"
              viewBox="0 0 32 32"
              aria-hidden="true"
            >
              <path
                d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
              />
            </svg>
            <p class="relative">
              {{ testimonial.text }}
            </p>
          </div>
          <footer class="mt-8">
            <div class="flex items-start space-x-4">
              <div
                class="inline-flex flex-shrink-0 rounded-full border-2 border-white"
                v-if="testimonial.image_url"
              >
                <img
                  class="h-12 w-12 rounded-full"
                  :src="testimonial.image_url"
                  alt=""
                />
              </div>
              <div>
                <div class="text-base font-medium text-white">
                  {{ testimonial.author }}
                </div>
                <div class="text-base font-medium text-indigo-200">
                  {{ testimonial.job }}
                </div>
              </div>
            </div>
          </footer>
        </blockquote>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
    },
  },
};
</script>
